import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SSO_INTEGRATIONS_STATES, SSO_INTEGRATIONS_STATES_MESSAGE_MAP, SSO_INTEGRATION_QUERY_PARAM } from "./constants";
import Loadable from "../../components/loadable/Loadable";
import { componentKey, setSsoIntegrationsLoaderState } from "./SSOIntegrationsSlice";
import { ssoIntegrationSignIn } from "./SSOIntegrationsSaga";

export default function SSOIntegrations({children}){
    
    const [queryParams] = useSearchParams();
    const { ssoIntegrationsLoaderState, redirectTo } = useSelector(state => state[componentKey]);

	const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (queryParams.has(SSO_INTEGRATION_QUERY_PARAM)) {
            const doSSOIntegration = queryParams.get(SSO_INTEGRATION_QUERY_PARAM)
			if(doSSOIntegration === "true"){
                queryParams.delete(SSO_INTEGRATION_QUERY_PARAM)
                const queryParamStr = queryParams.toString();
                dispatch(ssoIntegrationSignIn({
                    data: {
                        queryParamStr: queryParamStr
                    }
                }))
            }
		} 
        else {
            dispatch(setSsoIntegrationsLoaderState( {state: SSO_INTEGRATIONS_STATES.SSO_INTEGRATION_READY} ))
        }
    }, [])

    useEffect(() => {
        if(redirectTo){
            navigate(redirectTo)
        }
    }, [redirectTo])

    return <Loadable currentState={ssoIntegrationsLoaderState.state} loadingStates={[SSO_INTEGRATIONS_STATES.SSO_INTEGRATION_LOADING]} messageMap={SSO_INTEGRATIONS_STATES_MESSAGE_MAP} isNewLoadable={true}>
    { children }
  </Loadable>
}